/* ── Shop by Release Date ──────────────────────────────────────────────────── */
(function () {
  'use strict';

  var SRBD = window.SRBD || {};
  var STOREFRONT_TOKEN = SRBD.storefrontToken || '';
  var STOREFRONT_URL = window.Shopify
    ? 'https://' + window.Shopify.shop + '/api/2024-01/graphql.json'
    : '/api/2024-01/graphql.json';

  // ── DOM refs ────────────────────────────────────────────────────────────────
  var elLoading = document.getElementById('srbd-loading');
  var elError   = document.getElementById('srbd-error');
  var elEmpty   = document.getElementById('srbd-empty');
  var elGrid    = document.getElementById('srbd-grid');

  // ── Storefront GraphQL ──────────────────────────────────────────────────────
  function storefrontQuery(query, variables) {
    return fetch(STOREFRONT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) { return r.json(); });
  }

  // ── Fetch all collections matching "*Releases" ───────────────────────────────
  var COLLECTIONS_QUERY = '\
    query GetReleaseCollections($cursor: String) {\
      collections(first: 250, after: $cursor, query: "title:*Releases") {\
        pageInfo { hasNextPage endCursor }\
        edges {\
          node {\
            id\
            title\
            handle\
            image { url }\
            products(first: 1) { edges { node { id featuredImage { url } } } }\
          }\
        }\
      }\
    }';

  function fetchAllReleaseCollections() {
    var all = [];
    function fetchPage(cursor) {
      return storefrontQuery(COLLECTIONS_QUERY, cursor ? { cursor: cursor } : {})
        .then(function (resp) {
          var data = resp && resp.data && resp.data.collections;
          if (!data) throw new Error('No data returned from Storefront API');
          var edges = data.edges || [];
          edges.forEach(function (e) { all.push(e.node); });
          if (data.pageInfo.hasNextPage) {
            return fetchPage(data.pageInfo.endCursor);
          }
          return all;
        });
    }
    return fetchPage(null);
  }

  // ── Parse collection title → Date ────────────────────────────────────────────
  // Expected format: "April 9, 2026 Releases"
  function parseTitleDate(title) {
    var m = title.match(/^([A-Za-z]+)\s+(\d+),\s+(\d{4})\s+Releases$/);
    if (!m) return null;
    var months = { January:0,February:1,March:2,April:3,May:4,June:5,
                   July:6,August:7,September:8,October:9,November:10,December:11 };
    var mo = months[m[1]];
    if (mo === undefined) return null;
    return new Date(parseInt(m[3], 10), mo, parseInt(m[2], 10));
  }

  // ── Format date for tile display ─────────────────────────────────────────────
  function formatMonthDay(d) {
    var months = ['Jan','Feb','Mar','Apr','May','Jun',
                  'Jul','Aug','Sep','Oct','Nov','Dec'];
    return months[d.getMonth()] + ' ' + d.getDate();
  }

  // ── Render ────────────────────────────────────────────────────────────────────
  function render(collections) {
    var today = new Date();
    today.setHours(0,0,0,0);

    // Filter to only those with a parseable date >= today AND at least 1 product
    var items = [];
    collections.forEach(function (c) {
      var d = parseTitleDate(c.title);
      if (!d) return;
      if (d < today) return;
      var productEdges = c.products && c.products.edges;
      if (!productEdges || productEdges.length === 0) return;
      items.push({ collection: c, date: d });
    });

    if (items.length === 0) {
      elLoading.style.display = 'none';
      elEmpty.style.display = '';
      return;
    }

    // Sort ascending by date
    items.sort(function (a, b) { return a.date - b.date; });

    // Group by month + year
    var groups = [];
    var lastKey = null;
    items.forEach(function (item) {
      var key = item.date.getFullYear() + '-' + item.date.getMonth();
      if (key !== lastKey) {
        groups.push([]);
        lastKey = key;
      }
      groups[groups.length - 1].push(item);
    });

    var dividerColors = ['red', 'yellow'];
    var html = '';

    groups.forEach(function (group, gi) {
      // Alternating divider between month groups (not before the first group)
      if (gi > 0) {
        var color = dividerColors[(gi - 1) % 2];
        html += '<div class="srbd-month-divider srbd-month-divider--' + color + '"></div>';
      }

      group.forEach(function (item) {
        var c = item.collection;
        var d = item.date;

        // Background image: collection image, or first product image
        var bgImg = '';
        if (c.image && c.image.url) {
          bgImg = c.image.url;
        } else {
          var productEdges = c.products && c.products.edges;
          if (productEdges && productEdges.length > 0) {
            var fi = productEdges[0].node.featuredImage;
            if (fi && fi.url) bgImg = fi.url;
          }
        }

        var bgStyle = bgImg ? ' style="background-image:url(\'' + bgImg.replace(/'/g, '%27') + '\')"' : '';

        html += '<a class="srbd-tile" href="/collections/' + c.handle + '">';
        html += '<div class="srbd-tile__bg"' + bgStyle + '></div>';
        html += '<div class="srbd-tile__content">';
        html += '<div class="srbd-tile__month-day">' + formatMonthDay(d) + '</div>';
        html += '<div class="srbd-tile__year">' + d.getFullYear() + '</div>';
        html += '</div>';
        html += '</a>';
      });
    });

    elGrid.innerHTML = html;
    elLoading.style.display = 'none';
    elGrid.style.display = '';
  }

  // ── Init ──────────────────────────────────────────────────────────────────────
  fetchAllReleaseCollections()
    .then(function (collections) {
      render(collections);
    })
    .catch(function (err) {
      console.error('SRBD error:', err);
      elLoading.style.display = 'none';
      elError.style.display = '';
    });
})();
